/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Status_Expired2Inputs */

const en_settings_reportingapikeys_status_expired2 = /** @type {(inputs: Settings_Reportingapikeys_Status_Expired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Settings_Reportingapikeys_Status_Expired2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_status_expired2 = /** @type {((inputs?: Settings_Reportingapikeys_Status_Expired2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Status_Expired2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_status_expired2(inputs)
});
export { settings_reportingapikeys_status_expired2 as "settings_reportingApiKeys_status_expired" }